import { useCallback } from 'react';
import { createEvent } from '../services/chat-api.service';
import { useGetStoreInfo } from './useGetStoreInfo';

export function useCreateEvent() {
  const { currentSession, store } = useGetStoreInfo();

  const createEventCallback = useCallback(
    async (eventName: string, data?: Record<string, unknown>) => {
      if (!currentSession || !store) {
        console.warn('Cannot create event: session or store not available', {
          hasSession: !!currentSession,
          hasStore: !!store,
        });
        return;
      }

      try {
        await createEvent({
          storeId: store.id,
          eventName,
          data,
          session: currentSession,
        });
      } catch (error) {
        console.error('Failed to create event:', error);
      }
    },
    [currentSession, store]
  );

  return {
    createEvent: createEventCallback,
  };
}
